import { Pagination } from 'antd';

import type { IWorkJourneyManagementAttentionItem } from '@src/models/interfaces/workJourneyManagement.interface';

import { WorkJourneyAttentionTable } from './components/WorkJourneyAttentionTable';
import styles from './styles.module.less';

interface WorkJourneyAttentionSectionProps {
  items: IWorkJourneyManagementAttentionItem[];
  loading?: boolean;
  total?: number;
  page?: number;
  pageSize?: number;
  onPageChange?: (page: number) => void;
}

export const WorkJourneyAttentionSection = ({
  items,
  loading = false,
  total = 0,
  page = 1,
  pageSize = 10,
  onPageChange,
}: WorkJourneyAttentionSectionProps) => (
  <section className={styles.section}>
    <WorkJourneyAttentionTable items={items} loading={loading} />
    {total > pageSize && onPageChange && (
      <div className={styles.pagination}>
        <Pagination
          current={page}
          pageSize={pageSize}
          total={total}
          onChange={onPageChange}
          showSizeChanger={false}
        />
      </div>
    )}
  </section>
);
